import { useEffect, useRef, useState } from "react";
import "./styles.css";

type Props = {
    value: File | null;
    onChange: (file: File | null) => void;
    label: string;
    disabled?: boolean;
};

export default function FileInput({ value, onChange, label, disabled }: Props) {
    const inputRef = useRef<HTMLInputElement>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!value) {
            setPreviewUrl(null);
            return;
        }
        const url = URL.createObjectURL(value);
        setPreviewUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [value]);

    return (
        <button type="button" className="file-input" onClick={() => inputRef.current?.click()} disabled={disabled}>
            {previewUrl ? <img src={previewUrl} className="file-input-preview" alt={label} /> : <p className="file-input-label">{label}</p>}
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                className="file-input-native"
                onChange={(e) => onChange(e.target.files?.[0] ?? null)}
                disabled={disabled}
            />
        </button>
    );
}
